previousNetworkStatus